import { Flex } from "antd";

import { Loading } from "@components";
import { useFetchInfoTypesService } from "@hooks";
import { useListInfoType } from "@store";
import { EFileSort } from "@types";
import { useMemo, useState } from "react";
import { SortItem } from "../item";
import { getTestResultsQuery } from "@utils/card";
import { TestResultsItem } from "../item/TestResultsItem";
import { Section } from "../share-component";

export const ListTestResults = () => {
  const { testResultsList = [], isLoadingList } = useListInfoType();
  const [sort, setSort] = useState<EFileSort>(EFileSort.New);

    const query = useMemo(() => getTestResultsQuery(sort), [sort]);

  useFetchInfoTypesService("TestResults", query);

  return (
    <Flex gap={8} vertical>
      <Section title="Test Results">
        <SortItem sort={sort} setSort={setSort} />
        {isLoadingList ? (
          <Loading />
        ) : (
          testResultsList.map((i) => <TestResultsItem key={i._id} card={i} />)
        )}
      </Section>
    </Flex>
  );
};
